import { render, staticRenderFns } from "./DetailsComponent.vue?vue&type=template&id=b0a446de"
import script from "./DetailsComponent.vue?vue&type=script&lang=js"
export * from "./DetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailsComponent.vue?vue&type=style&index=0&id=b0a446de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports